import React from "react";
import { SideIllustration } from "../components/common/SideIllustration";
import { IMAGE_SOURCES } from "../mock/imageSources";

export default function About() {
  return (
    <div className="space-y-8">
      <section className="space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">About the Music Certification Board</h1>
        <p className="max-w-3xl text-sm leading-relaxed text-slate-700 sm:text-base">
          Global Music Conservatory is dedicated to providing reliable, transparent and musically relevant external certification for instrumentalists and vocalists. The conservatory works in partnership with teachers, schools and institutions worldwide to recognise structured progress in music performance and musicianship.
        </p>
        <p className="max-w-3xl text-sm leading-relaxed text-slate-700 sm:text-base">
          Our syllabi are designed to balance technical discipline with musical expression, allowing candidates to demonstrate what they have learned in a purposeful, supportive assessment environment. Every element of the examination process is designed to be clear, accessible and consistent across regions.
        </p>
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-white/80 p-5 shadow-sm backdrop-blur-xl md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:p-6">
        <div className="space-y-3">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Our mission</h2>
          <p className="text-sm leading-relaxed text-slate-700">
            The board&apos;s mission is to support sustained musical growth by offering examinations that are fair, clearly structured and musically meaningful. Certification is intended to reflect real learning and to provide candidates with a sense of achievement that aligns with their ongoing study.
          </p>
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Commitment to quality</h2>
          <p className="text-sm leading-relaxed text-slate-700">
            Quality assurance processes are embedded throughout the examination system, from syllabus development and examiner training through to standardisation and review. This ensures that candidates are assessed against stable standards, regardless of instrument, level or examination mode.
          </p>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.aboutLesson}
          alt="Formal music lesson with teacher and student at an instrument"
        />
      </section>

      <section className="space-y-4">
        <h2 className="text-base font-semibold tracking-tight text-slate-900">Philosophy of the Board</h2>
        <div className="grid gap-4 text-sm text-slate-700 sm:grid-cols-2">
          <div className="space-y-2">
            <h3 className="text-sm font-semibold text-slate-900">Structured progression</h3>
            <p>
              Examinations are organised into clearly defined levels, ensuring that each stage represents a meaningful step forward in technical, musical and interpretative development.
            </p>
          </div>
          <div className="space-y-2">
            <h3 className="text-sm font-semibold text-slate-900">Global access</h3>
            <p>
              Online and hybrid assessment options enable candidates, teachers and institutions in a wide range of locations to participate in the certification programme without compromising standards.
            </p>
          </div>
          <div className="space-y-2">
            <h3 className="text-sm font-semibold text-slate-900">Artistic integrity</h3>
            <p>
              Musical understanding, stylistic awareness and communicative performance are valued alongside technical security, ensuring that assessments reflect real artistry.
            </p>
          </div>
          <div className="space-y-2">
            <h3 className="text-sm font-semibold text-slate-900">Transparent evaluation</h3>
            <p>
              Marking criteria, descriptors and feedback practices are designed to be clear and practical, supporting constructive dialogue between teachers, candidates and the examination board.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
